import {
  Box,
  Container,
  Stack,
  Text,
  Image,
  Flex,
  VStack,
  Heading,
  SimpleGrid,
  StackDivider,
} from '@chakra-ui/react';
import {useMemo} from 'react';
import {LocaleKey, setLocale, translate} from '../i18n';

const PrivacyScreen: React.FC<{lang?: LocaleKey}> = ({lang}) => {
  const contents = useMemo(() => {
    setLocale(lang || 'ja');
    return [
      {
        title: translate('privacy.acquisition.title'),
        text: translate('privacy.acquisition.text'),
      },
      {
        title: translate('privacy.use.title'),
        text: translate('privacy.use.text'),
      },
      {
        title: translate('privacy.disclosure.title'),
        text: translate('privacy.disclosure.text'),
      },
      {
        title: translate('privacy.tools.title'),
        text: translate('privacy.tools.text'),
      },
      {
        title: translate('privacy.contact.title'),
        text: translate('privacy.contact.text'),
      },
    ] as const;
  }, [lang]);

  return (
    <Container maxW={'2xl'} backgroundColor={'primary.900'} height={'100vh'}>
      <SimpleGrid columns={1} spacing={6} py={18}>
        <Flex>
          <Image
            rounded={'md'}
            alt={'logme'}
            src={'./logo192.png'}
            fit={'contain'}
            w={'100%'}
            h={'96px'}
          />
        </Flex>
        <VStack spacing={6}>
          <Box as={'header'}>
            <Heading
              lineHeight={1}
              fontWeight={600}
              fontSize={'xl'}
              color={'secondary.500'}
            >
              {translate('privacy.title')}
            </Heading>
          </Box>
        </VStack>
        <Stack
          spacing={2}
          direction={'column'}
          divider={<StackDivider borderColor={'gray.200'} />}
        >
          {contents.map((content, index) => (
            <Paragraph {...content} key={index} />
          ))}
        </Stack>
      </SimpleGrid>
    </Container>
  );
};

export {PrivacyScreen};

interface ParagraphProps {
  title: string;
  text: string;
}

const Paragraph: React.FC<ParagraphProps> = ({title, text}) => {
  return (
    <Box>
      <Text fontSize={'sm'} color={'secondary.200'} fontWeight={'600'} mb={'2'}>
        {title}
      </Text>
      <Text
        fontSize={'md'}
        color={'white'}
        fontWeight={'500'}
        whiteSpace={'pre-wrap'}
      >
        {text}
      </Text>
    </Box>
  );
};
